// extracted by mini-css-extract-plugin
module.exports = {"shape":"Style_shape__decNq","line1":"Style_line1__HXbDd","line2":"Style_line2__d_bEd"};